const dateTimeFormatter = new Intl.DateTimeFormat('en-GB', {
  dateStyle: 'short',
  timeStyle: 'short',
})

export const formatDateTime = (isoDate: string) =>
  dateTimeFormatter.format(new Date(isoDate))
